import React from "react"
import { Helmet } from "react-helmet"
import { graphql, Link } from "gatsby"
import { Layout } from "../../components/layout"
import { Categorie } from "../../data/formations/type"
import { FormationHeadGroup, categorieToStrPl } from "../../data/types/formations"
import { FormationHead } from "../../components/formations/FormationHead"

interface Props {
  data: {
    allFormations: {
      totalCount: number
      distinct: Categorie[]
      group: FormationHeadGroup[]
    }
  }
}

const ORDER = {
  CF: 0,
  CS: 1,
  CA: 2,
}

const Formations: React.FC<Props> = ({ data }) => (
  <Layout>
    <Helmet title="Formations 2026/2027" />
    <div className="container">
      <div className="row mt-3">
        <div className="col my-3">
          <h1>Formations 2026/2027</h1>
          <div className="card mb-3">
            <div className="card-body">
              <h5 className="card-title">Nouvelle offre de formations</h5>
              <p className="card-text">
                Dès la rentrée 2026, de nouvelles formations seront disponibles autour de quatre familles d’acteurs&nbsp;: encadrants bénévoles, encadrants professionnels, arbitres et dirigeants. Des formations pour tous, mais surtout pour accompagner les acteurs du tir à l’arc dans l’évolution de leurs missions et favoriser l’engagement bénévole et les professionnels qui font vivre, chaque jour, le tir à l’arc sur le terrain.
                <br />
                Pour y parvenir, la fédération a entièrement repensé son schéma des formations en mettant l’accent sur la lisibilité et l’accessibilité. L’objectif est de permettre à chacun d’identifier plus facilement son parcours de formation et de bénéficier d’un accompagnement adapté à ses besoins.
                <br />
                <strong>Quatre niveaux de formation</strong>
                <br />
                L’offre de formations a été simplifiée avec une organisation commune à l’ensemble des filières. Quel que soit le parcours choisi, les formations s’articuleront autour de quatre&nbsp;niveaux qui permettent d’organiser et hiérarchiser le développement des compétences.
                <br />
                Le premier niveau se veut accessible au plus grand nombre et constitue la porte d’entrée de chaque filière. Les niveaux suivants permettent une montée en compétences progressive avec des contenus de plus en plus approfondis pour celles et ceux qui souhaitent développer leur expertise.
                <br />
                <strong>Des formations hybrides et plus accessibles</strong>
                <br />
                Cette évolution marque l’intégration renforcée du e-learning dans les parcours de formation. De nombreux modules seront accessibles via la plateforme Moodle et notamment les contenus théoriques. Certaines formations proposeront des sessions en présentiel pour compléter le parcours.
                <br />
                L’inscription aux formations se fait en deux étapes :  depuis l’espace licencié FFTA puis via le lien "S'inscrire" vers helloasso pour le paiement.
              </p>
              <p className="card-text">
                <a
                  className="btn btn-outline-primary btn-lg"
                  href="https://view.genially.com/69f0b8d92ea02055c820611b"
                  role="button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Présentation des nouvelles formations
                </a>
              </p>
            </div>
          </div>

          <div className="formations-container">
            {data.allFormations.group.filter(g => g.fieldValue != 'CS').sort((g1, g2) => ORDER[g1.fieldValue] - ORDER[g2.fieldValue]).map(group => (
              <div className="formations-group-container">
                <h3>
                  {categorieToStrPl(group.fieldValue)} <span className="badge badge-pill badge-secondary">{group.totalCount}</span>
                </h3>
                {group.nodes.map(formation => (
                  <FormationHead formation={formation} />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default Formations

export const pageQuery = graphql`
  query AllFormationsHeads {
    allFormations(sort: { fields: [reference], order: [ASC] }) {
      totalCount
      distinct(field: categorie)
      group(field: categorie) {
        totalCount
        fieldValue
        nodes {
          id
          url
          date(formatString: "DD/MM/YYYY", locale: "FR")
          titre
          reference
          categorie
          tags
          categories
          armes
          diplome
          age
        }
      }
    }
  }
`
